import React from 'react';
import { useData } from '../backend/firebase';

const PrizePoolBreakdown = () => {
    const { donationsContent } = useData();
    
    // Pull the total raised from the database, fallback to 0 if loading
    const raised = Number(donationsContent?.raised || 0);

    // --- MATH HELPERS ---
    const formatMoney = (val) => {
        return new Intl.NumberFormat('en-US', { 
            style: 'currency', 
            currency: 'USD', 
            minimumFractionDigits: 0, 
            maximumFractionDigits: 0 
        }).format(val);
    };

    const totalRemaining = raised * 0.10;
    
    // NOTE: Update this number if the total number of non-placing players changes!
    // Based on the $334 / $8.35 math in your mockup, this assumes 40 players.
    const nonPlacingPlayersCount = 10; 
    const perPlayerAmount = totalRemaining / nonPlacingPlayersCount;

    // --- COLOR PALETTES ---
    const colorsA = {
        first: '#FFD700',   // Vibrant Gold
        second: '#E0E0E0',  // Bright Silver
        third: '#CD7F32',   // Rich Bronze
        fourth: '#B088FF'   // Bright Purple
    };

    const colorsB = {
        first: '#C5A835',   // Muted Gold
        second: '#A0A0A0',  // Muted Silver
        third: '#9E6A44',   // Muted Bronze
        fourth: '#8B6BBD'   // Muted Purple
    };

    const PrizeRow = ({ place, pctStr, pctVal, color }) => (
        <div style={{ 
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', 
            padding: '12px 15px', background: 'rgba(255,255,255,0.03)', 
            borderRadius: 8, marginBottom: 8, border: '1px solid rgba(255,255,255,0.05)' 
        }}>
            {/* Color applied to Place text */}
            <span style={{ fontSize: 16, fontWeight: 'bold', color: color }}>{place}</span>
            <div style={{ textAlign: 'right' }}>
                {/* Color applied to Money text */}
                <div style={{ fontSize: 20, fontWeight: '900', color: color }}>
                    {formatMoney(raised * pctVal)}
                </div>
                <div style={{ fontSize: 11, color: '#8F9EB5', fontWeight: 'bold', marginTop: 2 }}>
                    {pctStr} OF POOL
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ width: '100%', margin: '30px 0' }}>
            <style>{`
                .prize-pool-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 30px;
                    background: rgba(0,0,0,0.15);
                    padding: 30px;
                    border-radius: 16px;
                    border: 1px solid rgba(255,255,255,0.05);
                }
                .prize-column {
                    display: flex;
                    flex-direction: column;
                }
                @media (max-width: 768px) {
                    .prize-pool-grid {
                        grid-template-columns: 1fr;
                        padding: 15px;
                        gap: 20px;
                    }
                }
            `}</style>

            <div className="prize-pool-grid">
                {/* A Bracket */}
                <div className="prize-column">
                    <h3 style={{ textAlign: 'center', color: '#FFF', marginBottom: 20, textTransform: 'uppercase', letterSpacing: 1, fontSize: 18 }}>
                        🏆 Championship Bracket Prizes
                    </h3>
                    <PrizeRow place="1st Place" pctStr="32%" pctVal={0.32} color={colorsA.first} />
                    <PrizeRow place="2nd Place" pctStr="16%" pctVal={0.16} color={colorsA.second} />
                    <PrizeRow place="3rd Place" pctStr="8%" pctVal={0.08} color={colorsA.third} />
                    <PrizeRow place="4th Place" pctStr="4%" pctVal={0.04} color={colorsA.fourth} />
                </div>

                {/* B Bracket */}
                <div className="prize-column">
                    <h3 style={{ textAlign: 'center', color: 'A0AEC0', marginBottom: 20, textTransform: 'uppercase', letterSpacing: 1, fontSize: 18 }}>
                        🛡️ Challengers Bracket Prizes
                    </h3>
                    <PrizeRow place="1st Place" pctStr="16%" pctVal={0.16} color={colorsB.first} />
                    <PrizeRow place="2nd Place" pctStr="8%" pctVal={0.08} color={colorsB.second} />
                    <PrizeRow place="3rd Place" pctStr="4%" pctVal={0.04} color={colorsB.third} />
                    <PrizeRow place="4th Place" pctStr="2%" pctVal={0.02} color={colorsB.fourth} />
                </div>

                {/* Remaining Pool Note */}
                <div style={{ 
                    gridColumn: '1 / -1', textAlign: 'center', padding: '15px', 
                    background: 'rgba(0,0,0,0.2)', borderRadius: 8, marginTop: 10, 
                    fontSize: 14, color: '#A0AEC0', border: '1px dashed rgba(255,255,255,0.1)' 
                }}>
                    The remaining <strong>10%</strong> ({formatMoney(totalRemaining)}) will be split equally between the remaining teams 
                    <span style={{color: '#A0AEC0', fontWeight: 'bold'}}> ({formatMoney(perPlayerAmount)} per team)</span>.
                </div>
            </div>
        </div>
    );
};

export default PrizePoolBreakdown;